export default __webpack_public_path__ + "static/media/basiercirclemono-regular-webfont.971c8ebd.woff";